import { defineStore } from "pinia";
import { useAuthStore } from "./auth";
import axios from "axios";

export const useUserStore = defineStore("user", {
    state: () => ({
        user: {}
    }),
    
    actions: {
        async getUser() {
         const authStore = useAuthStore(); 
            try {
            const response = await axios.get(`/users/${authStore.user.id}`);
            this.user = response.data.user;
            } catch (err) {
            console.error("Error getting user profile:", err);
            }
        },
       async getMandatoryTwoFactorStatus() {
         const authStore = useAuthStore();
            try {
                const response = await axios.get(`/users/mandatory-2fa/${authStore.user.id}`);
                authStore.isOrgMandatoryTwoFaStatus = response.data.mandatory_two_factor
            } catch (err) {
                 console.error("Error getting user profile:", err);
            }
            }
    }
    });